import { PRODUCTION_AUDIO_CATALOG, type ProductionAudioAssetId } from './production-catalog.ts';
import type { ProductionAudioBus, ProductionAudioRegistryEntry } from './production-registry.ts';

type CandidateTuple = readonly [
  ProductionAudioAssetId,
  ProductionAudioBus,
  string,
  'recorded-candidate' | 'generated-candidate',
  string,
  string | null,
  string,
  string | null,
  string,
  string,
];

const CANDIDATES: readonly CandidateTuple[] = [
  [
    'music.builder-workshop',
    'music',
    'Provisional 60-second builder score',
    'generated-candidate',
    'Anthony Palma using Adobe Firefly',
    'Adobe Firefly Generate music beta interface observed 2026-08-14',
    'Adobe Firefly Generative AI terms; commercial use permitted for beta output unless expressly restricted by the product',
    'Free daily generations',
    'deea7afdd00ebcc3fdbfb48f95c937840aefd7f0d9dfd5ff34952671e6d613c0',
    '49e58c777faf486d69fa501f9ebc7441fb8207021081574215013f84b1e4a487',
  ],
  [
    'ride.lift-loop',
    'ride',
    'Lift segment mechanism with midpoint return loop (SFX-02)',
    'recorded-candidate',
    '3maze',
    'The Elevator / Sonniss GDC 2017',
    'Sonniss GDC Bundle License',
    'Free GDC 2017 bundle',
    'b2afc7e371d817fe43a9a9550397141e6b7b704849738f4335aa5b6876b20705',
    'f8a7efb13f14cc7032d9aad5866854ceb4ff559b0062ac1dce47d3671c7f9c91',
  ],
  [
    'ride.launch',
    'ride',
    'Launch boost segment loop (SFX-13)',
    'recorded-candidate',
    'Soundrangers',
    'Wind / Sonniss GDC 2018',
    'Sonniss GDC Bundle License',
    'Free GDC 2018 bundle',
    '29d11a429ee3da7d7ee3347075015f4a957ede2adfcacc67b6224c0b084a46d7',
    'c7af969dfb4359a304c418547480274f0584c64c6105f37271403890471b7e60',
  ],
  [
    'ride.brake',
    'ride',
    'Brake/deceleration sound (SFX-15)',
    'recorded-candidate',
    'Airborne Sound',
    'Vehicles Passenger Trains 1 / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    'b5c2e08d015a93ccc33367b0256aa011d8416d79efd42c66c84c9d3bfbca79ca',
    '91e97b959a7dc304bbac326748d9d02031a6dc448865ab3afb0e9543feb9977e',
  ],
  [
    'ride.coasting-loop',
    'ride',
    'Speed-reactive coasting loop (SFX-14)',
    'recorded-candidate',
    'Soundrangers',
    'Wind / Sonniss GDC 2018',
    'Sonniss GDC Bundle License',
    'Free GDC 2018 bundle',
    'f1302790e4ac24fa024b6a45409b165afe3d72e21e6aaa52717e6128505d6674',
    '1d9fd44d5b5543a982e8021cdefbf4782a8f9169870b11e6489d06dbc7e0269b',
  ],
  [
    'environment.park-model',
    'environment',
    'Park Model ambience (SFX-06)',
    'recorded-candidate',
    'Raconteur Sound',
    'Spring in the Pacific Northwest / Sonniss GDC 2017',
    'Sonniss GDC Bundle License',
    'Free GDC 2017 bundle',
    'bfc4add58a0a2f56eef3f69dc82f7aa01eb0f2ccea0192a7f320427667acc330',
    'ecdbcb46dae28313a98266ac3fc7f4b27145d0b40821feeaee4fb1133dadd949',
  ],
  [
    'environment.toyworks',
    'environment',
    'Toyworks ambience (SFX-49)',
    'recorded-candidate',
    'Raconteur Sound',
    'Spring in the Pacific Northwest / Sonniss GDC 2017',
    'Sonniss GDC Bundle License',
    'Free GDC 2017 bundle',
    '2ee0bfcf7d167ed9a13691d15938a0eb360f89a99eeaefb4bb47523b11c31cf7',
    '85f2ccd8b8e822467a7edd255bc10a1c3cd725b2b996efd1fec79cd4a1cd8d35',
  ],
  [
    'environment.afterglow',
    'environment',
    'Afterglow ambience (SFX-32)',
    'recorded-candidate',
    'Airborne Sound',
    'Light and Dark Drones / Sonniss GDC 2018',
    'Sonniss GDC Bundle License',
    'Free GDC 2018 bundle',
    '1e18d30604ce78747afb3e7c82c3e3acf4b7590552a0e9f420578cc3363559a7',
    'b95be2a1b86edd01825f6cb7c21de9230029f7f77307245cb6bfd5dffbbc5cc5',
  ],
  [
    'ride.photo',
    'ride',
    'Ride photo shutter (SFX-48)',
    'recorded-candidate',
    '2496 Sound Effects',
    'Hollywood Cameras / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    'bf1c7ae64841472f624c0b23577f549b88fac2ef54c0d3257362c1120f407663',
    '8d8173ca66b653e7d72626b02402011b55a84e8511c091f2aa7a14abf92fad02',
  ],
  [
    'ui.general-click',
    'ui',
    'General non-Build UI click (SFX-61)',
    'recorded-candidate',
    '3maze',
    'Buttons and Switches / Sonniss GDC 2016',
    'Sonniss GDC Bundle License',
    'Free GDC 2016 bundle',
    'eb0950975bdcce599fc2eda0f8a15b17d50c5521b85bd55a6d9c970b8b5873b6',
    'a76fb20cc5fa1b2d70696b6cd3614aecd6822293fef79304250ac13991cf3aeb',
  ],
  [
    'ui.track-placement',
    'ui',
    'Successful track placement (SFX-21)',
    'recorded-candidate',
    'InspectorJ',
    'UI Mechanical / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    '2a1a0b839a829aceb3888856f630a369c90f13ca561f395da77ed9532a542665',
    'c7730b0f19190a205bea7cc128896942d7ac7e7a16f2c175ff6b43963637a98b',
  ],
  [
    'ui.build-selection',
    'ui',
    'Build selection/options (SFX-62)',
    'recorded-candidate',
    '3maze',
    'Buttons and Switches / Sonniss GDC 2016',
    'Sonniss GDC Bundle License',
    'Free GDC 2016 bundle',
    'f86e35097ba7b2242c6480964da1f84956e83fb07119b875ffdf8021c0e47a64',
    '92f7e5e1f312706f754c5aa791c34f6d560c4b48245d610fa0761554ea111662',
  ],
  [
    'ui.undo-delete',
    'ui',
    'Undo/delete (SFX-17)',
    'recorded-candidate',
    'Chris Logsdon',
    'Ambient Puzzle SFX Pack / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    '1e8bfacada22c64cfdc065d1406edbf7ff66a97197d9ed49fa93189964c19fd9',
    '63e48b349564af21a272e39b13ba9d65808e276da5f2c8726c3c6facbdd89c68',
  ],
  [
    'ui.publish-success',
    'ui',
    'Confirmed publish success (SFX-18)',
    'recorded-candidate',
    'Chris Logsdon',
    'Ambient Puzzle SFX Pack / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    'e3859e9901dbae1f534e3d840a47fefec239156736eceb9b4c68bb82c97b8ecd',
    '6d2529997e4526b5e466365112efe8dca4473e790c7a98878ce5858e94b8d97a',
  ],
  [
    'ui.coaster-complete',
    'ride',
    'Provisional coaster completion (SFX-19)',
    'recorded-candidate',
    'InspectorJ',
    'UI Mechanical / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    '198da984525896c7df9e61b73132100aec75c8feef8fcbb7208951302e80abdf',
    '15919354c371f2d8a65a146b897d1c3e3f4e35fe6a0e9cbf1faeced40b0af53a',
  ],
  [
    'ui.system-failure',
    'ui',
    'Actual system failure only (SFX-20)',
    'recorded-candidate',
    'InspectorJ',
    'UI Mechanical / Sonniss GDC 2019',
    'Sonniss GDC Bundle License',
    'Free GDC 2019 bundle',
    'b5b6fc0704123c0b2a15d65eb50ed0aff87841687597a75867b90188edfea4b1',
    '5a49f38001fb731b8fbebca51bb43b4824d82e02967379b666ed73727bcc97ec',
  ],
];

export const MASTERED_AUDIO_REGISTRY: readonly ProductionAudioRegistryEntry[] = CANDIDATES.map(
  ([
    id,
    bus,
    role,
    source,
    creator,
    generatorModelVersion,
    license,
    subscriptionTier,
    sourceHash,
    finalHash,
  ]) => ({
    id,
    bus,
    role,
    source,
    runtimeUrl: PRODUCTION_AUDIO_CATALOG.find((asset) => asset.id === id)?.url ?? null,
    creator,
    generatorModelVersion,
    prompt:
      id === 'music.builder-workshop'
        ? 'Vibe: warm, playful, polished. Style: marimba, pizzicato, instrumental. Purpose: game building, creative focus. Energy: Medium. Tempo: Medium. Duration: 60 seconds. Variation: Track 3.'
        : null,
    license,
    subscriptionTier,
    sourceHash,
    finalHash,
    processing: [
      'art/phase-9/audio/mastering-recipe.json',
      'art/phase-9/audio/mastering-results.json',
    ],
    inGameSafe: false,
    socialExportSafe: false,
    attribution: null,
    status: 'audition_required',
  }),
);
